import script from "./PreSaleCommPlan.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreSaleCommPlan.vue?vue&type=script&setup=true&lang=ts"

import "./PreSaleCommPlan.vue?vue&type=style&index=0&id=1240ec1d&lang=less&scope=true"

const __exports__ = script;

export default __exports__